/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { SocialExportGetYoutubeCapabilitiesQueryResponse, SocialExportGetYoutubeCapabilitiesPathParams, SocialExportGetYoutubeCapabilities400, SocialExportGetYoutubeCapabilities401, SocialExportGetYoutubeCapabilities403, SocialExportGetYoutubeCapabilities404 } from "../models/SocialExportGetYoutubeCapabilities";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { socialExportGetYoutubeCapabilities } from "../axios/socialExportGetYoutubeCapabilities";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const socialExportGetYoutubeCapabilitiesQueryKey = (connectionId: SocialExportGetYoutubeCapabilitiesPathParams["connectionId"]) => ["api-v2", { url: '/social-export/v1/platforms/youtube/:connectionId/capabilities', params: {connectionId:connectionId} }] as const

export type SocialExportGetYoutubeCapabilitiesQueryKey = ReturnType<typeof socialExportGetYoutubeCapabilitiesQueryKey>

export function socialExportGetYoutubeCapabilitiesQueryOptions(connectionId: SocialExportGetYoutubeCapabilitiesPathParams["connectionId"], config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = socialExportGetYoutubeCapabilitiesQueryKey(connectionId)
        return queryOptions<SocialExportGetYoutubeCapabilitiesQueryResponse, ResponseErrorConfig<SocialExportGetYoutubeCapabilities400 | SocialExportGetYoutubeCapabilities401 | SocialExportGetYoutubeCapabilities403 | SocialExportGetYoutubeCapabilities404>, SocialExportGetYoutubeCapabilitiesQueryResponse, typeof queryKey>({
         enabled: !!(connectionId),
         queryKey,
         queryFn: async ({ signal }) => {
            return socialExportGetYoutubeCapabilities(connectionId, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns which actions the stored OAuth credentials can perform (upload, delete, add to playlists).
 * @summary Get YouTube connection capabilities
 * {@link /social-export/v1/platforms/youtube/:connectionId/capabilities}
 */
export function useSocialExportGetYoutubeCapabilities<TData = SocialExportGetYoutubeCapabilitiesQueryResponse, TQueryData = SocialExportGetYoutubeCapabilitiesQueryResponse, TQueryKey extends QueryKey = SocialExportGetYoutubeCapabilitiesQueryKey>(connectionId: SocialExportGetYoutubeCapabilitiesPathParams["connectionId"], options: 
{
  query?: Partial<QueryObserverOptions<SocialExportGetYoutubeCapabilitiesQueryResponse, ResponseErrorConfig<SocialExportGetYoutubeCapabilities400 | SocialExportGetYoutubeCapabilities401 | SocialExportGetYoutubeCapabilities403 | SocialExportGetYoutubeCapabilities404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? socialExportGetYoutubeCapabilitiesQueryKey(connectionId)
         

         const query = useQuery({
          ...socialExportGetYoutubeCapabilitiesQueryOptions(connectionId, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<SocialExportGetYoutubeCapabilities400 | SocialExportGetYoutubeCapabilities401 | SocialExportGetYoutubeCapabilities403 | SocialExportGetYoutubeCapabilities404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}